export enum FileListType {
  VIDEO = 'video',
  IMAGE = 'image',
}
